<template>
  <AppAlert
    v-if="alert?.show"
    :message="alertMessage"
    dismissable
    icon-classes="hi hi-warning"
    type="warning"
  />
</template>

<script>
import { mapGetters } from 'vuex';
import AppAlert from '~/components/AppAlert.vue';

export default {
  name: 'InsightsAlert',
  components: { AppAlert },
  computed: {
    ...mapGetters(['alert']),
    alertMessage() {
      const PREFIX = 'Time period automatically changed.';
      const MESSAGES = {
        bounds: 'Insights only displays data up to six months.',
        exceedsLimit: 'Insights only displays data for two months at a time.'
      };

      return `${PREFIX} ${MESSAGES[this.alert.type] || MESSAGES.exceedsLimit}`;
    },
  },
};
</script>
